import { post } from './client';
import { API_ENDPOINTS } from '../config/api';

interface RegisterResponse {
  success?: boolean;
  error?: {
    message?: string;
  };
}

interface ResetPasswordResponse {
  success?: boolean;
  error?: {
    message?: string;
  };
}

interface Card {
  access_key: string;
  last_four: string;
}

interface CardsResponse {
  cards: Card[];
  error?: {
    message?: string;
  };
}

export async function register(username: string) {
  return post<RegisterResponse>(API_ENDPOINTS.REGISTER, { username });
}

export async function resetPassword(username: string) {
  return post<ResetPasswordResponse>(API_ENDPOINTS.PASSWORD_RESET, { username });
}

export async function accountCards(loginKey: string) {
  return post<CardsResponse>(API_ENDPOINTS.CARDS, { login_key: loginKey });
}

export default {
  register,
  resetPassword,
  accountCards,
};
